import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationDto } from 'src/app/models/dtos/notification-dto';

export interface NotificationModalComponentData {
  notification: NotificationDto;
}

@Component({
  selector: 'app-notification-modal',
  templateUrl: './notification-modal.component.html',
  styleUrls: ['./notification-modal.component.scss'],
  standalone: false
})
export class NotificationModalComponent implements OnInit {
  private data = inject<NotificationModalComponentData>(MAT_DIALOG_DATA);


  notification: NotificationDto;

  constructor() { }

  ngOnInit(): void {
    this.notification = this.data.notification;
  }
}